import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

export interface PersistedAppStateModel {
  navOpen: boolean;
}

export class SetNavOpenedAction {
  static readonly type = '[PersistedAppState] SetNavOpenedAction';

  constructor(public navOpen: boolean) {
  }
}

export const PersistedAppStateName = 'persistedAppState';

@State<PersistedAppStateModel>({
  name: PersistedAppStateName,
  defaults: {
    navOpen: true,
  },
})
@Injectable()
export class PersistedAppState {
  @Selector([PersistedAppState])
  public static get(state: PersistedAppStateModel): PersistedAppStateModel {
    return state;
  }

  @Selector([PersistedAppState])
  public static navOpen(state: PersistedAppStateModel): boolean {
    return state.navOpen;
  }

  @Action(SetNavOpenedAction)
  setNavOpenAction(ctx: StateContext<PersistedAppStateModel>, action: SetNavOpenedAction) {
    ctx.patchState({
      navOpen: action.navOpen,
    });
  }
}
